import React, { useState } from 'react';
import {
  Input,
  Button,
  Row,
  Col,
  Checkbox,
  Typography,
  Space,
  Card,
  Collapse,
} from 'antd';
import {
  DeleteOutlined,
  CopyOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
} from '@ant-design/icons';

import styled from 'styled-components';

import FormSection from './FormSection';

const { Title, Text, Link } = Typography;
const { Panel } = Collapse;

const FormGroup = ({ group, groupIndex, form }) => {
  return (
    <Collapse
      style={{ marginBottom: 12 }}
      defaultActiveKey={['1']}
      expandIconPosition="end"
    >
      <Panel header={group.title} key="1">
        <div style={{ padding: 5, marginBottom: -8 }}>
          {group.sections.map((section, sIdx) => (
            <FormSection
              key={section.id}
              section={section}
              groupIndex={groupIndex}
              sectionIndex={sIdx}
              form={form}
            />
          ))}
        </div>
      </Panel>
    </Collapse>
  );
};

export default FormGroup;
